<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

  <div class="card shadow-sm border-0 mx-auto" style="max-width: 760px;">
    <div class="card-body p-4 text-center">

      <div class="display-5 mb-3">✅</div>
      <h3 class="fw-bold mb-2">Application Submitted</h3>
      <p class="text-muted mb-4">
        Your verification application has been submitted and is awaiting review.
      </p>

      <div *ngIf="loading" class="py-3">
        <div class="spinner-border"></div>
      </div>

      <div *ngIf="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div *ngIf="application as app" class="bg-light rounded p-3 text-start mb-4">
        <div class="row g-3 small">
          <div class="col-md-6">
            <span class="text-muted">Country:</span>
            <strong>{{ app.jurisdictionCode }}</strong>
          </div>

          <div class="col-md-6">
            <span class="text-muted">Status:</span>
            <strong>{{ app.status }}</strong>
          </div>

          <div class="col-md-6">
            <span class="text-muted">Tier:</span>
            <strong>{{ app.tierCode }}</strong>
          </div>

          <div class="col-md-6">
            <span class="text-muted">Submitted:</span>
            <strong>{{ app.submittedAt | date:'medium' }}</strong>
          </div>
        </div>

        <div *ngIf="app.reviewNotes" class="alert alert-warning mt-3 mb-0">
          <strong>Review notes:</strong> {{ app.reviewNotes }}
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2 flex-wrap">
        <a class="btn btn-primary btn-sm" routerLink="/compliance">
          View My Applications
        </a>

        <a class="btn btn-outline-secondary btn-sm" routerLink="/dashboard">
          Back to Dashboard
        </a>
      </div>

    </div>
  </div>

  <app-footer></app-footer>
</main>
</div>